export default __webpack_public_path__ + "static/media/vertical2.ec12cd23.jpeg";